import { styled, Dialog, IconButton } from '@mui/material';

export const Styles = {
  Container: styled('div')(({ theme }) => ({
    flex: '0.7',
    width: '100%',
    marginTop: '25px',
    borderRadius: '5px',
    maxWidth: '800px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      marginTop: '15px'
    }
  })),

  FirstInfos: styled('div')(({ theme }) => ({
    backgroundColor: '#FFF',
    display: 'flex',
    borderRadius: '8px',
    flexDirection: 'row',
    padding: '20px',
    marginBottom: '15px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      marginLeft: '0',
      padding: '15px'
    }
  })),

  TopImage: styled('img')(({ theme }) => ({
    height: '390px',
    borderRadius: '2px',
    width: '520px',
    position: 'unset',
    cursor: 'zoom-in',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: 'auto',
      margin: '0 auto',
      maxHeight: '300px'
    }
  })),

  NegotiatingBanner: styled('div')(() => ({
    width: '100%',
    backgroundColor: '#6B3A2A',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0',
    borderRadius: '4px',
    fontWeight: 700,
    fontSize: '0.85rem',
    letterSpacing: '0.08em',
    textAlign: 'center'
  })),

  RightContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginLeft: '15px',
    marginRight: '15px',
    width: '250px',
    maxHeight: '390px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: '0',
      marginTop: '20px'
    }
  })),

  GalleryGrid: styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 150px)',
    gap: '10px',
    maxHeight: 'calc(3 * 130px)',
    overflowY: 'auto',
    paddingRight: '20px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      width: '100%',
      gap: '8px',
      paddingRight: '0'
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)'
    }
  })),

  GalleryContainer: styled('div')(({ theme }) => ({
    maxWidth: '800px',
    maxHeight: 'calc(3 * 155px)',
    overflowX: 'auto',
    overflowY: 'auto',
    padding: '20px',
    display: 'flex',
    background: '#ffffff',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      padding: '15px',
      maxHeight: 'none',
      overflow: 'visible'
    }
  })),

  FeaturesContainer: styled('div')(({ theme }) => ({
    // Card de características
    maxWidth: '800px',
    width: '100%',
    // Define altura máxima do card e rolagem interna para não extrapolar
    maxHeight: '220px',
    overflowY: 'auto',
    overflowX: 'hidden',

    // Layout em grade estável
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: '10px',

    borderRadius: '5px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.15)',
    padding: '12px',

    // Evita “jump” de layout em responsivo
    alignContent: 'start',

    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      // Mantém card consistente em mobile
      maxHeight: '260px',
      padding: '12px',
      boxShadow: 'none'
    }
  })),

  FeatureBox: styled('div')({
    // Cada item da grade com altura e alinhamento fixos
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',

    height: '36px',
    padding: '0 10px',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    background: '#fff',

    // Evita desalinhamento por alturas dinâmicas
    boxSizing: 'border-box'
  }),

  FeatureText: styled('span')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000000',

    // Nunca quebrar em duas linhas e cortar com reticências
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',

    [theme.breakpoints.down('md')]: {
      fontSize: '13px'
    }
  })),

  TopHeading: styled('h3')({
    // Título externo ao card
    fontWeight: 700,
    fontSize: '16px',
    color: '#04682e',
    marginTop: '18px',
    marginLeft: '27px'
  }),

  FeatureBox2: styled('div')(({ theme }) => ({
    // Contêiner da seção de características
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  })),

  AgentContainer: styled('div')(({ theme }) => ({
    width: '455px',
    height: '160px',
    background: '#fffff',
    borderRadius: '18px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: 'auto',
      flexDirection: 'column',
      padding: '15px'
    }
  })),

  AgentBoxBot: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      alignItems: 'center',
      textAlign: 'center'
    }
  })),

  FeaturesDiv: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '780px',
    padding: '10px',
    marginBottom: '35px',
    gap: '25px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '15px',
      marginBottom: '20px',
      gap: '30px',
      '& > div:last-child': {
        order: 0,
        width: '100%',
        marginBottom: '15px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        borderRadius: '12px'
      },

      '& > div:first-child': {
        width: '100%',
        padding: '10px',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px'
      }
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px',
      gap: '20px',
      '& > div:last-child': {
        padding: '12px'
      }
    }
  })),

  AgentBox: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    minWidth: '112px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      gap: '20px',
      alignItems: 'flex-start'
    }
  })),

  AgentPhoto: styled('img')(({ theme }) => ({
    width: '112px',
    height: '112px',
    border: '2px solid #04682e',
    borderRadius: '10px',
    objectFit: 'cover',
    marginBottom: '12px',
    [theme.breakpoints.down('md')]: {
      width: '80px',
      height: '80px',
      marginBottom: '0'
    }
  })),

  AgentName: styled('p')(({ theme }) => ({
    fontWeight: '700',
    margin: '1px',
    fontSize: '18px',
    paddingBottom: '20px',
    paddingTop: '35px',
    color: '#382414',
    [theme.breakpoints.down('md')]: {
      padding: '0 0 15px 0',
      fontSize: '16px'
    }
  })),

  AgentInfos: styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '8px',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      gap: '12px'
    }
  })),

  AgentPhone: styled('p')(({ theme }) => ({
    fontWeight: '700',
    fontSize: '16px',
    margin: '1px',
    color: '#382414',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })),

  AgentEmail: styled('p')(({ theme }) => ({
    fontWeight: '700',
    margin: '1px',
    fontSize: '16px',
    color: '#382414',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      wordBreak: 'break-all'
    }
  })),

  AgentHeading: styled('h3')(({ theme }) => ({
    fontWeight: '700',
    fontSize: '16px',
    color: '#04682e',
    marginBottom: '12px',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  })),

  TopImageContainer: styled('div')(({ theme }) => ({
    position: 'relative',
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    maxWidth: '100%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      justifyContent: 'flex-start'
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center'
    },
    [theme.breakpoints.down('sm')]: {
      '& img': {
        width: '100%',
        height: 'auto',
        maxHeight: '300px'
      }
    }
  })),

  Propertytitle: styled('h1')({
    color: '#382414',
    fontWeight: '600',
    lineHeight: '1.2',
    marginBottom: '8px',
    justifyContent: 'space-evenly',
    width: 'auto',
    fontSize: '26px',
    marginTop: '1px'
  }),

  PropertyCodeBox: styled('div')(({ theme }) => ({
    borderRadius: '5px',
    border: '1px solid #04682E',
    maxWidth: '150px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      textAlign: 'center',
      padding: '10px',
      marginBottom: '10px'
    }
  })),

  PropertyCodeText: styled('p')({
    color: '#04682E',
    fontSize: '18px',
    fontWeight: '600',
    margin: '0',
    padding: '0 5px 0 5px'
  }),

  IconsContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    marginTop: '5px',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '230px',
    marginBottom: '5px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'space-between',
      gap: '2px',
      marginTop: '2px',
      padding: '0 2px'
    },
    [theme.breakpoints.down('sm')]: {
      gap: '2px',
      overflowX: 'auto',
      paddingBottom: '10px'
    }
  })),

  DetailsBox: styled('div')(({ theme }) => ({
    display: 'flex',
    marginRight: '3px',
    alignItems: 'center',
    backgroundColor: 'white',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '35px',
    maxHeight: '40px',
    borderRadius: '3px',
    border: 'solid rgb(204, 204, 204) 0.5px',
    maxWidth: '40px',
    marginBottom: '10px',
    [theme.breakpoints.down('md')]: {
      flex: '1',
      padding: '30px 29px'
    }
  })),

  DetailsIcon: styled('img')(({ theme }) => ({
    maxWidth: '40px',
    maxHeight: '30px',
    marginBottom: '8px',
    paddingTop: '8px',
    [theme.breakpoints.down('md')]: {
      width: '20px',
      height: '20px'
    }
  })),

  DetailsText: styled('div')(({ theme }) => ({
    fontSize: '14px',
    margin: '0',
    color: 'rgb(155, 155, 155)',
    marginTop: '-3px',
    fontWeight: '500',
    padding: '0',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px'
    }
  })),

  ImageContainer: styled('div')(({ theme }) => ({
    position: 'relative',
    width: '145px',
    height: '132px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'transform 0.2s, border 0.2s',
    '&:hover': {
      transform: 'scale(1.03)'
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '120px'
    }
  })),

  Image: styled('img')(({ theme }) => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)'
    }
  })),

  DescriptionContainer: styled('div')(({ theme }) => ({
    maxWidth: '800px',
    width: '100%',
    background: '#ffffff',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    marginTop: '15px',
    padding: '20px',
    borderRadius: '8px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      boxShadow: 'none',
      borderTop: '1px solid #e0e0e0',
      borderBottom: '1px solid #e0e0e0',
      marginTop: '20px',
      padding: '0 15px'
    }
  })),

  Title: styled('h2')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    margin: '20px',
    lineHeight: '12px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      margin: '15px 0 10px 0',
      paddingTop: '10px',
      lineHeight: '1.3'
    }
  })),

  Description: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '27px',
    color: '#212529',
    '& li > p': {
      marginTop: 0,
      marginBottom: 0
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '24px',
      margin: '0 0 15px 0',
      '& p': {
        margin: '8px 0'
      },
      '& li > p': {
        margin: 0
      }
    }
  })),

  SingleText: styled('p')(({ theme }) => ({
    margin: '25px',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '27px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      margin: '0 0 20px 0',
      paddingBottom: '15px',
      fontWeight: '500',
      color: '#04682e'
    }
  })),

  ButtonLeft: styled('div')({
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'black',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    marginLeft: '5px',
    borderRadius: '5px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    cursor: 'pointer',
    opacity: 0.55
  }),

  ButtonRight: styled('div')({
    position: 'absolute',
    right: '0',
    marginRight: '5px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'black',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    cursor: 'pointer',
    opacity: 0.55
  }),

  ZoomModal: styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
      backgroundColor: 'rgba(0,0,0,0.9)',
      maxWidth: 'none',
      width: 'auto',
      margin: theme.spacing(2)
    },
    '& .MuiDialogContent-root': {
      padding: 0
    }
  })),

  ZoomImage: styled('img')({
    maxWidth: '90vw',
    maxHeight: '90vh',
    display: 'block',
    margin: '0 auto'
  }),

  ZoomNavButton: styled(IconButton)(({ theme }) => ({
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'white',
    backgroundColor: 'rgba(0,0,0,0.5)',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.8)'
    },
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1)
    }
  })),

  ZoomCloseButton: styled(IconButton)(({ theme }) => ({
    position: 'fixed',
    top: theme.spacing(2),
    right: theme.spacing(2),
    color: 'white',
    backgroundColor: 'rgba(0,0,0,0.5)',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.8)'
    },
    zIndex: 1
  }))
};
